/** 分红记录路由 */
export default {
    name: 'aBonus',
    path: 'aBonus',
    meta: {
        title: '分红记录'
    },
    component: ()=>import('@/pages/aBonus/aBonus.vue'),
    children: []
}